export const PRESETS = {
  styledErrorImageContainer: {
    width: {
      desktop: 641,
    },
  },

  styledErrorMessageWrapper: {
    maxWidth: 300,
  },
};
